<div *ngIf="searchText?.length > 0 && !isLoading && products.skuResults.length === 0; else showProducts"
    class="section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h1>We didn't find anything for</h1>
                <p>&quot;{{searchText}}&quot;</p>
                <p><strong>Search Help</strong></p>
                <p>
                    - Check your search for typos<br />
                    - Use more generic search results<br />
                    - The product you're searching for may not exist on this site<br />
                    - Need help finding something? Call <a href="tel:0860747877">(0860) 747-877</a>
                </p>
            </div>
            <p>&nbsp;</p>
        </div>
    </div>
</div>

<ng-template #showProducts>
    <app-categories [categories]="products?.categoryResults" [isLoading]="isLoading"
        (catProdFilter)="updateSubCategory($event)"></app-categories>
    <app-product-brands [brands]="brands" (brandClicked)="updateBrand($event)"></app-product-brands>
    <div class="section">
        <!-- container -->
        <div class="container-store">
            <!-- row -->
            <div class="row">
                <!-- STORE -->
                <div id="store" class="col-md-12">
                    <!-- store top filter -->
                    <div class="store-filter clearfix mainpagi">
                        <div class="store-sort">
                            <app-shared-store-sort [pageSize]="resultsPerPage"
                                [pageSortBy]="sortBy + ' '  + sortByDirection"
                                (sortPageResultSize)="updateResultsPerPage($event)"
                                (sortByPage)="updateSortBy($event)"></app-shared-store-sort>
                        </div>

                        <ul class="store-grid">
                            <pagination-controls class="top-pagination" (pageChange)="updatePageNumber($event)"
                                previousLabel="" nextLabel="">
                            </pagination-controls>
                        </ul>

                        <div style="float:right;width: 100%;">
                            <ul class="store-grid2">
                                <li class="active" (click)="updateGridView(true)" #grid><i class="fa fa-th"></i>
                                </li>
                                <li (click)="updateGridView(false)" #list><i class="fa fa-th-list"></i>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- store products -->
                    <div class="row">
                        <div *ngFor="let product of products?.skuResults | paginate: pageConfig">
                            <app-shared-product-item [productItem]="product" [isLoading]="isLoading"
                                [isGridView]="isGridView" [wishlist]="wishlist">
                            </app-shared-product-item>
                        </div>
                    </div>
                    <!-- /store products -->

                    <!-- store bottom filter -->
                    <div class="store-filter clearfix store-pagination" *ngIf="!isLoading">
                        <p class="store-pagination-results"><strong>Results: {{pageConfig.totalItems}}</strong></p>
                        <pagination-controls class="store-pagination-controls" (pageChange)="updatePageNumber($event)"
                            previousLabel="" nextLabel="">
                        </pagination-controls>
                    </div>
                    <!-- /store bottom filter -->

                </div>
                <!-- /STORE -->
            </div>
            <!-- /row -->
        </div>
        <!-- /container -->
    </div>
    <div class="spinner-wrapper" *ngIf="isLoading">
        <app-spinner></app-spinner>
    </div>
</ng-template>
